import { configureStore } from '@reduxjs/toolkit'
import { AppStatusType } from './appStatusReducer'
import appStatusReducer from './appStatusReducer';
import userReducer from './userReducer';
import requestsReducer from "./requestsReducer";
import usersReducer from "./usersReducer";
import districtsReducer from "./districtsReducer";

export const store = configureStore({
  reducer: {
    appStatus: appStatusReducer,
    user: userReducer,
    requests: requestsReducer,
    users: usersReducer,
    districts: districtsReducer,
  },
  middleware: (getDefaultMiddleware) => getDefaultMiddleware({serializableCheck: false}),
  devTools: true,
})

export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch
export type AsyncThunkConfig = {
  fulfilledMeta: {
    appStatus?: AppStatusType.succeeded | AppStatusType.idle | AppStatusType.loading
    appMessage?:  string
  },
  state: RootState
}
export type fulfilledMetaType = {
  arg: unknown;
  requestId: string;
  requestStatus: 'fulfilled',
  appStatus: AppStatusType.succeeded | AppStatusType.idle | AppStatusType.loading
  appMessage?:  string
}
